export default function _isFunction(x) {
  return Object.prototype.toString.call(x) === '[object Function]';
}


//////////////////
// WEBPACK FOOTER
// ./~/ramda/es/internal/_isFunction.js
// module id = Ez4V
// module chunks = 22